import {
  IDSK,
  QuerySearchArgs,
  Resource,
  SearchableResourceConnectionNew,
} from "@examspark/types";

import { GraphQLAPI, fragments } from "..";
import { search } from "../queries/search";

import * as resource from "./resource";

export const createIssue = async (data: Partial<Resource>) => {
  const { id, sk, ...params } = data;
  if (!data.workspaceId) throw new Error("Missing field: workspaceId");
  if (!id) throw new Error("Missing field: id");

  // create issue
  const createIssue = await resource.createNumberedResource({
    ...params,
    sk: `issue`,
    resourceId: [id, sk].join("/"),
  });

  // attach issue to asset
  const issue = createIssue.data?.createResource;
  if (!issue) throw new Error("Unable to create issue.");

  await resource.createResource({
    label: "AttachIssueToResource",
    variables: {
      id,
      schemaVersion: "2020-01-01",
      sk: ["issue", `${issue.id}/${issue.sk}`].join(":"),
      workspaceId: params.workspaceId,
      resourceId: [issue.id, issue.sk].join("/"),
    },
  });

  return createIssue.data?.createResource;
};

export const deleteIssue = async (issue: Resource) => {
  if (!issue.resourceId) throw new Error("Missing resourceId");

  // delete issue
  await resource.deleteResource({
    id: issue.id,
    sk: issue.sk,
    workspaceId: issue.workspaceId,
  });
  await resource.deleteResource({
    id: issue.resourceId.split("/")[0],
    sk: ["issue", `${issue.id}/${issue.sk}`].join(":"),
    workspaceId: issue.workspaceId,
  });

  if (issue.issueKey) {
    await resource.deleteResource({
      id: issue.resourceId.split("/")[0],
      sk: ["issue-key", issue.issueKey].join("#"),
      workspaceId: issue.workspaceId,
    });
  }
};

export const updateIssue = async (data: Partial<Resource>) => {
  const result = await resource.updateResource(data);
  return result.data?.updateResource;
};

export const getIssuesForResource = async (variables: IDSK) => {
  const result = await resource.getResource({
    label: "GetIssues",
    fields: `
  id
  sk
  issues {
    id
    sk
    name
  }
`,
    variables,
  });
  return result.data?.getResource;
};

export const searchIssues = async (variables: QuerySearchArgs) => {
  const result = await GraphQLAPI.client.query<{
    search: SearchableResourceConnectionNew;
  }>({
    query: search({
      fields: `
      ${fragments.resource.id} 
      ${fragments.resource.basic} 
      ${fragments.resource.issue}
      ${fragments.resource.alignments}
      creator {
        firstName
        lastName
        email
      }
      assigneeId
      resourceId
      resource {
        ${fragments.resource.id}
      }
      `,
    }),
    variables,
  });

  return result.data?.search;
};
